<template>
  <div>
    <h3 class="title">Diagnose</h3>
    <div v-if="diagnose && diagnose.object">
      <div class="ui segment">
        {{ diagnose.object.diagnose_text }}
      </div>
    </div>
    <p v-else>No diagnose</p>
  </div>
</template>

<script>
export default {
  props: {
    diagnose: {
      type: Object,
      default: () => {
        object: '';
      }
    }
  }
};
</script>

<style scoped>
.title {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/visit_history_components/Diagnose.vue